export default "__VITE_ASSET__zDjC5aVC__"